import request from "root/js/request";

export const getKeywordPredict = async ({
  date_from,
  wb_search,
  month_width,
  predict_trand,
  extra_fields,
  weighted_price_per_position,
  orders_per_position,
  limit,
  ...rest
}) => {
  const response = await request({
    url: `/wb_dynamic/keyword_predict/`,
    method: "GET",
    params: {
      date_from,
      wb_search,
      month_width,
      predict_trand,
      extra_fields,
      weighted_price_per_position,
      orders_per_position,
      limit,
      ...rest,
    },
  });
  return response.data;
};

export const postKeywordPredict = async ({
  date_from,
  wb_search,
  month_width,
  predict_trand,
  extra_fields,
  weighted_price_per_position,
  orders_per_position,
  limit,
  product_ids,
  ...rest
}) => {
  const response = await request({
    url: `/wb_dynamic/keyword_predict/`,
    method: "POST",
    params: {
      date_from,
      wb_search,
      month_width,
      predict_trand,
      extra_fields,
      weighted_price_per_position,
      orders_per_position,
      limit,
      ...rest,
    },
    data: {
      product_ids,
    },
  });
  return response.data;
};
